var render = function () {
  var _vm$totalOrders, _vm$totalOrders$total, _vm$totalOrders2, _vm$totalOrders2$tota, _vm$totalOrders3, _vm$totalOrders3$tota, _vm$totalOrders4, _vm$totalOrders4$tota, _vm$logisticOrders, _vm$logisticOrders2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "w-full flex"
  }, [_c('div', {
    staticClass: "w-full max-w-xs mdmax:w-full mb-6"
  }, [_c('div', {
    staticClass: "date-range relative text-xs shadow-sm"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    on: {
      "update": _vm.setDate
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-between items-center gap-6 mb-6 mdmax:flex-wrap mdmax:gap-2"
  }, [_c('router-link', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-amber-700 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md",
    attrs: {
      "to": "/order",
      "title": "Klik untuk melihat selengkapnya"
    }
  }, [_c('div', [_c('p', {
    staticClass: "text-white mdmax:text-sm"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.totalDelivery')))]), _c('p', {
    staticClass: "text-lg font-bold text-white"
  }, [_vm._v(_vm._s((_vm$totalOrders = _vm.totalOrders) === null || _vm$totalOrders === void 0 ? void 0 : (_vm$totalOrders$total = _vm$totalOrders.total_delivery) === null || _vm$totalOrders$total === void 0 ? void 0 : _vm$totalOrders$total.total))])]), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Courier', {
    attrs: {
      "color": "neutral-700",
      "height": "18",
      "width": "18"
    }
  })], 1)]), _c('router-link', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-amber-700 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md",
    attrs: {
      "title": "Klik untuk melihat selengkapnya",
      "to": "/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=ONGOING&sort=DESC"
    }
  }, [_c('div', {}, [_c('p', {
    staticClass: "text-white mdmax:text-sm"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.totalProcessed')))]), _c('p', {
    staticClass: "text-lg font-bold text-white"
  }, [_vm._v(_vm._s((_vm$totalOrders2 = _vm.totalOrders) === null || _vm$totalOrders2 === void 0 ? void 0 : (_vm$totalOrders2$tota = _vm$totalOrders2.total_proceed) === null || _vm$totalOrders2$tota === void 0 ? void 0 : _vm$totalOrders2$tota.total))])]), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Truck', {
    attrs: {
      "color": "neutral-700",
      "height": "15",
      "width": "19"
    }
  })], 1)]), _c('router-link', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-amber-700 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md",
    attrs: {
      "title": "Klik untuk melihat selengkapnya",
      "to": "/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=COMPLETED&sort=DESC"
    }
  }, [_c('div', {}, [_c('p', {
    staticClass: "text-white mdmax:text-sm"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.totalDelivered')))]), _c('p', {
    staticClass: "text-lg font-bold text-white"
  }, [_vm._v(_vm._s((_vm$totalOrders3 = _vm.totalOrders) === null || _vm$totalOrders3 === void 0 ? void 0 : (_vm$totalOrders3$tota = _vm$totalOrders3.total_delivered) === null || _vm$totalOrders3$tota === void 0 ? void 0 : _vm$totalOrders3$tota.total))])]), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Delivered', {
    attrs: {
      "color": "neutral-700",
      "height": "20",
      "width": "19"
    }
  })], 1)]), _c('router-link', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-amber-700 rounded-md flex justify-between items-start transition-all duration-200  hover:shadow-soft shadow-md",
    attrs: {
      "title": "Klik untuk melihat selengkapnya",
      "to": "/order?page=1&per_page=10&search_keyword=&start_date=&end_date=&status=COMPLAIN&sort=DESC"
    }
  }, [_c('div', {}, [_c('p', {
    staticClass: "text-white mdmax:text-sm"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.totalFailed')))]), _c('p', {
    staticClass: "text-lg font-bold text-white"
  }, [_vm._v(_vm._s((_vm$totalOrders4 = _vm.totalOrders) === null || _vm$totalOrders4 === void 0 ? void 0 : (_vm$totalOrders4$tota = _vm$totalOrders4.total_failed) === null || _vm$totalOrders4$tota === void 0 ? void 0 : _vm$totalOrders4$tota.total))])]), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Undelivered', {
    attrs: {
      "color": "neutral-700",
      "height": "20",
      "width": "19"
    }
  })], 1)])], 1), _c('div', {
    staticClass: "flex items-start gap-6 mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-2/6 px-3 py-4 bg-white mdmax:order-2 mdmax:w-full shadow-md"
  }, [_c('div', {}, [_c('p', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.successOrder.title')))]), !_vm.logisticReady ? [_vm._m(0)] : [_c('TableComponent', {
    attrs: {
      "compact": "",
      "columns": _vm.columnsSuccess,
      "list": (_vm$logisticOrders = _vm.logisticOrders) === null || _vm$logisticOrders === void 0 ? void 0 : _vm$logisticOrders.top_success_delivery
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref) {
        var entry = _ref.entry,
            column = _ref.column,
            index = _ref.index;
        return [column.field === 'no' ? _c('span', {
          staticClass: "block text-center"
        }, [_vm._v(_vm._s(index + 1))]) : column.field === 'logo' ? _c('span', {
          staticClass: "flex justify-center text-center"
        }, [entry.logo ? _c('img', {
          staticClass: "w-16",
          attrs: {
            "src": entry.logo
          }
        }) : _c('LogisticPlaceholder', {
          attrs: {
            "logisticName": entry.name
          }
        })], 1) : _c('span', {
          staticClass: "block text-center"
        }, [_vm._v(_vm._s(entry[column.field] || '0'))])];
      }
    }])
  })]], 2), _c('div', {
    staticClass: "my-6"
  }, [_c('p', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.failedOrder.title')))]), !_vm.logisticReady ? [_vm._m(1)] : [_c('TableComponent', {
    attrs: {
      "compact": "",
      "columns": _vm.columnsFailed,
      "list": (_vm$logisticOrders2 = _vm.logisticOrders) === null || _vm$logisticOrders2 === void 0 ? void 0 : _vm$logisticOrders2.top_failed_delivery
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref2) {
        var entry = _ref2.entry,
            column = _ref2.column,
            index = _ref2.index;
        return [column.field === 'no' ? _c('span', {
          staticClass: "block text-center"
        }, [_vm._v(_vm._s(index + 1))]) : column.field === 'logo' ? _c('span', {
          staticClass: "flex justify-center text-center"
        }, [entry.logo ? _c('img', {
          staticClass: "w-16",
          attrs: {
            "src": entry.logo
          }
        }) : _c('LogisticPlaceholder', {
          attrs: {
            "logisticName": entry.name
          }
        })], 1) : _c('span', {
          staticClass: "block text-center"
        }, [_vm._v(_vm._s(entry[column.field] || '0'))])];
      }
    }])
  })]], 2)]), _c('div', {
    staticClass: "w-4/6 mdmax:order-1 mdmax:w-full"
  }, [_c('div', {
    staticClass: "mb-6 px-3 py-4 bg-white shadow-md"
  }, [_c('p', {
    staticClass: "text-lg font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.shippingCost')))]), _c('div', {
    staticClass: "flex items-center gap-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 flex justify-center items-center"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_vm.isExpenseReady ? _c('PieChart', {
    attrs: {
      "data": _vm.chartData,
      "options": _vm.chartOptions
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex-1 flex-col flex justify-center gap-6"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-10 h-5 bg-primary-500"
  }), _c('div', [_c('p', {
    staticClass: "text-xs text-neutral-500 mb-0.5"
  }, [_vm._v("Bulan Ini")]), _c('p', {
    staticClass: "text-sm text-neutral-700"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.expenses.current)))])])]), _c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-10 h-5 bg-secondary-500"
  }), _c('div', [_c('p', {
    staticClass: "text-xs text-neutral-500 mb-0.5"
  }, [_vm._v("Bulan Lalu")]), _c('p', {
    staticClass: "text-sm text-neutral-700"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")(_vm.expenses.previous)))])])])])])]), _c('div', {
    staticClass: "px-3 py-4 bg-white shadow-md"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('p', {
    staticClass: "text-lg font-bold"
  }, [_vm._v(_vm._s(_vm.$t('dashboard.onGoingDeliveries.title')))]), _c('router-link', {
    staticClass: "inline-block text-primary-500 font-medium mdmax:text-sm ",
    attrs: {
      "to": "/order"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.seeAll')) + " ")])], 1), _c('TableComponent', {
    attrs: {
      "compact": "",
      "columns": _vm.orderColumns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref3) {
        var entry = _ref3.entry,
            column = _ref3.column;
        return [column.field === 'created_time' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(entry.created_time)))]) : column.field === 'sender_location' ? _c('div', {
          staticClass: "block"
        }, [_c('p', [_vm._v(_vm._s(entry.pickup_address))]), entry.pickup_detail ? _c('p', {
          staticClass: "text-xs text-neutral-500 mt-1"
        }, [_vm._v(_vm._s(entry.pickup_detail))]) : _vm._e()]) : column.field === 'receiver_location' ? _c('div', {
          staticClass: "block"
        }, [_c('p', [_vm._v(_vm._s(entry.destination_address))]), entry.destination_detail ? _c('p', {
          staticClass: "text-xs text-neutral-500 mt-1"
        }, [_vm._v(_vm._s(entry.destination_detail) + " ")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  })], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-40 flex items-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-40 flex items-center justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  })]);
}]

export { render, staticRenderFns }